var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlay(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.00048 4.53702C7.90939 4.48301 7.80562 4.45407 7.69972 4.45315C7.59382 4.45222 7.48957 4.47934 7.39754 4.53175C7.30552 4.58417 7.22901 4.66 7.17578 4.75155C7.12255 4.84311 7.0945 4.94712 7.09448 5.05302V18.947C7.0945 19.0529 7.12255 19.1569 7.17578 19.2485C7.22901 19.34 7.30552 19.4159 7.39754 19.4683C7.48957 19.5207 7.59382 19.5478 7.69972 19.5469C7.80562 19.546 7.90939 19.517 8.00048 19.463L19.7235 12.516C19.813 12.4629 19.8872 12.3874 19.9387 12.2969C19.9902 12.2064 20.0173 12.1041 20.0173 12C20.0173 11.8959 19.9902 11.7936 19.9387 11.7031C19.8872 11.6127 19.813 11.5371 19.7235 11.484L8.00048 4.53702Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlay);
export default __webpack_public_path__ + "static/media/play.79d59bc0e38d2921d121b376d0c50213.svg";
export { ForwardRef as ReactComponent };